import React, { useEffect } from 'react'
import { background } from '../../../assets/backgrounds'
import { Button } from 'cwp-components/forms/Buttons'
import { PostCard } from 'cwp-components/cards/PostCard'
import { useNavigate } from 'react-router-dom'
import { BlogPost, useArticleTemplate } from 'common/hooks/useArticleTemplate'
import moment from 'moment'
import { Link } from 'react-router-dom'

const DiscoverLegalPerspective = ({ articles }: { articles: BlogPost[] }) => {
  const navigate = useNavigate()
  const { featuredArticle, loadFeaturedArticle } = useArticleTemplate()
  useEffect(loadFeaturedArticle, [loadFeaturedArticle])

  return (
    <>
      <div className='relative h-full w-full !z-[2]'>
        <img
          src={background.discoverLaw._01}
          className='max-sm:hidden absolute md:w-full md:h-[1475.5px] right-0 top-[195px] !z-[-1] h-full '
        />
        <img
          src={background.discoverLaw._02}
          alt=''
          className=' absolute left-0 md:top-[200px] bottom-[200px] md:w-full !z-[-999]'
        />
        <div className='px-[10px] lg:px-[80px] relative mb-12'>
          <div className='flex flex-col'>
            <div className='w-full'>
              <h1 className='text-lg lg:text-[40px]  font-bold my-10'>
                You might want to discover the legal perspective
              </h1>
            </div>
            <div className='flex flex-col md:flex-row justify-between items-center'>
              <div className='w-full md:w-5/12 mx-auto md:px-7'>
                <p className='text-[#101828]  text-lg md:text-2xl font-medium leading-[26px] tracking-wide md:my-20'>
                  Explore our expert-authored blogs and articles by top legal
                  professionals to gain valuable insights into the legal
                  services
                </p>
                <p className='mb-10 text-[#25395C]  text-[12px] md:text-[16px] font-medium leading-[24px] tracking-wide'>
                  Unlock a wealth of legal knowledge by diving into our
                  exclusive collection of blogs and articles, authored by
                  seasoned attorneys. Whether you're seeking insights on the
                  latest legal trends or guidance on complex issues, our
                  platform offers you direct access to the expertise of top
                  legal professionals. Start exploring now to stay informed and
                  make well-informed decisions for your legal needs.
                </p>
              </div>
              <div className='md:w-6/12 mx-auto md:px-5 relative'>
                <img
                  height='293px'
                  width='auto'
                  content='cover'
                  className='rounded-md'
                  src={featuredArticle['cover_image']}
                />
                <p className='mt-4 mb-4 font-bold'>
                  <Link to={`/articles/${featuredArticle.slug}`}>
                    {featuredArticle.title}
                  </Link>
                </p>
                <p className='text-muted'>
                  {moment(featuredArticle['publish_date']).format(
                    'Do MMMM, YYYY',
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='md:px-[80px]  relative !z-[3]'>
          <div className='mt-[-20px] mx-auto'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4   gap-[30px] lg:gap-[59px]'>
              {articles?.slice(0, 8).map((blog, idx) => (
                <PostCard
                  className='h-[371px] w-full max-w-[330px] mx-auto'
                  data={blog}
                  count={idx}
                  key={idx}
                />
              ))}
            </div>
            <div className=' flex justify-center my-20'>
              <Button
                className='btn-primary'
                onClick={() => navigate('/articles')}
              >
                Show more
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DiscoverLegalPerspective
